// extracted by mini-css-extract-plugin
module.exports = {"customerInfo":"styles_customerInfo__3Y6sh"};